import React from "react";
import NotificationsList from "notifications/components/NotificationsList";
import { alertsViewSet, openedAlertSet, selectAlertsView, selectAllAlerts, selectNewAlerts, selectOpenedAlert } from "slices/notificationsSlice";
import { useAppDispatch, useAppSelector } from "store";

const AlertsDashboard = () => {
  const dispatch = useAppDispatch();

  const allAlerts = useAppSelector(selectAllAlerts);
  const newAlerts = useAppSelector(selectNewAlerts);
  const currentView = useAppSelector(selectAlertsView);
  const openedAlert = useAppSelector(selectOpenedAlert);

  if (!currentView && !openedAlert) {
    return null;
  }

  const handleOpenAlert = (notify) => {
    dispatch(openedAlertSet(notify));
  };

  const handleClose = () => {
    dispatch(alertsViewSet(""));
  };

  const handleSetViewNew = () => {
    if (currentView !== "new") {
      dispatch(alertsViewSet("new"));
    }
  };

  const handleSetViewAll = () => {
    if (currentView !== "all") {
      dispatch(alertsViewSet("all"));
    }
  };

  return (
    <NotificationsList
      onSetViewAll={handleSetViewAll}
      onSetViewNew={handleSetViewNew}
      onClose={handleClose}
      allNotifications={allAlerts}
      newNotifications={newAlerts}
      currentView={currentView}
      openedNotification={openedAlert}
      onOpenNotification={handleOpenAlert}
      isAlert
    />
  );
};

export default AlertsDashboard;
